import { __ } from '~/locale';

export const CONFIRM_DANGER_MODAL_ID = 'confirm-danger-modal';
export const CONFIRM_DANGER_MODAL_TITLE = __('Are you absolutely sure?');
export const CONFIRM_DANGER_MODAL_BUTTON = __('Confirm');
export const CONFIRM_DANGER_WARNING = __(
  'This action can lead to data loss. To prevent accidental actions we ask you to confirm your intention.',
);
export const CONFIRM_DANGER_PHRASE_TEXT = __('Enter the following to confirm:');
export const CONFIRM_DANGER_MODAL_CANCEL = __('Cancel');
